import { render, staticRenderFns } from "./ProductRatesSummary.vue?vue&type=template&id=33a51b45&scoped=true&"
import script from "./ProductRatesSummary.vue?vue&type=script&lang=js&"
export * from "./ProductRatesSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a51b45",
  null
  
)

export default component.exports